// (function () {

//   function updateRow(wrapper) {
//     console.log('hi get')
//     const qtyInput = wrapper.querySelector('.cartorderQty');
//     const meterInput = wrapper.querySelector('.cartmeterQty');
//     const hiddenInput = wrapper.querySelector('.meterHidden');
//     const line = wrapper.dataset.lineIndex;

//     if (!qtyInput || !meterInput || !line) return;

//     console.log('hi get')

//     const step = parseInt(meterInput.step, 10);

//     let qty = parseInt(qtyInput.value, 10);
//     let meter = parseInt(meterInput.value, 10);

//     if (isNaN(qty) || qty < 1) qty = 1;
//     if (isNaN(meter) || meter < step) meter = step;
//     meter = Math.round(meter / step) * step;

//     qtyInput.value = qty;
//     meterInput.value = meter;
//     if (hiddenInput) hiddenInput.value = meter;

//     const totalQty = qty * meter;

//     // if(document.body.classList.contains('template-cart')){
//     //     const themeCart = document.querySelector('theme-cart');
//     //     if (themeCart && typeof themeCart.updateQuantity === 'function') {
//     //     themeCart.updateQuantity(line, totalQty, {
//     //         'Qty': qty,
//     //         'Meter': meter
//     //     });
//     //     } else {
//     //     console.warn('theme-cart element not found — cannot update quantity/properties.');
//     //     }
//     // }else{
//     //     const themeCartdrawer = document.querySelector('cart-drawer');
//     //     if (themeCartdrawer && typeof themeCartdrawer.updateQuantity === 'function') {
//     //     themeCartdrawer.updateQuantity(line, totalQty, {
//     //         'Qty': qty,
//     //         'Meter': meter
//     //     });
//     //     } else {
//     //     console.warn('theme-cart element not found — cannot update quantity/properties.');
//     //     }

//     // }



//         fetch('/cart.js')
//         .then(response => response.json())
//         .then(cart => {
//             const lineItem = cart.items[line - 1];

//             if (!lineItem) {
//             console.warn('Line item not found:', line);
//             return;
//             }

//             // Keep all existing properties
//             const properties = {
//             ...(lineItem.properties || {}),
//             'Qty': qty,
//             'Meter': meter
//             };

//             if (document.body.classList.contains('template-cart')) {
//             const themeCart = document.querySelector('theme-cart');

//             if (themeCart && typeof themeCart.updateQuantity === 'function') {
//                 themeCart.updateQuantity(line, totalQty, properties);
//             } else {
//                 console.warn('theme-cart element not found — cannot update quantity/properties.');
//             }

//             } else {
//             const themeCartdrawer = document.querySelector('cart-drawer');

//             if (themeCartdrawer && typeof themeCartdrawer.updateQuantity === 'function') {
//                 themeCartdrawer.updateQuantity(line, totalQty, properties);
//             } else {
//                 console.warn('cart-drawer element not found — cannot update quantity/properties.');
//             }
//             }
//         });

//   }

//   // Capture phase, so this runs BEFORE the event bubbles into #cart-form
//   // and triggers the theme's own onFormChange for these inputs.
//   document.addEventListener('change', function (e) {
//     console.log('hii change');
//     if (e.target.matches('.cartorderQty, .cartmeterQty')) {
//         console.log('hii change 1');
//       e.stopPropagation();
//       const wrapper = e.target.closest('.custom-meter-order');
//       console.log('wrapper',wrapper);
//       if (wrapper) updateRow(wrapper);
//     }
//   }, true);

// })();


(function () {

  let busy = false;

  function limits(wrapper) {
    const moq     = parseInt(wrapper.dataset.moq, 10) || 1;

    const orderunit = wrapper.getAttribute('data-unit');
    //const isMeter  = !!qtyInput; 
    const isMeter = orderunit === 'M';

    // const isMeter = !!wrapper.querySelector('.cartorderQty');
    // const base    = isMeter ? moq : 1;
     const base    = moq || 1;
    const raw     = wrapper.dataset.available;
    const stock   = raw === '' || raw === undefined ? null : (parseInt(raw, 10) || 0);

    if (stock === null) return { min: moq, step: base, max: null, stock: null, moq: moq };
    if (stock <= 0)     return { min: moq, step: base, max: 0, stock: 0, moq: moq, soldOut: true };
    if (stock < moq)    return { min: stock, step: 1, max: stock, stock: stock, moq: moq, reduced: true };

    return { min: moq, step: base, max: stock, stock: stock, moq: moq };
  }

  function showNotice(wrapper, msg, invalid) {
    wrapper.querySelectorAll('.cartorderQty, .cartmeterQty').forEach(function (el) {
      el.classList.toggle('is-invalid', !!invalid);
    });

    const el = wrapper.querySelector('.uom-notice');
    if (!el) return;
    if (!msg) { el.hidden = true; el.textContent = ''; return; }
    el.textContent = msg;
    el.hidden = false;
  }

  function syncAttrs(wrapper, L) {
    const qtyInput  = wrapper.querySelector('.cartorderQty');
    const unitInput = wrapper.querySelector('.cartmeterQty');

    unitInput.min  = L.min;
    unitInput.step = L.step;
    if (L.max === null) unitInput.removeAttribute('max');
    else unitInput.max = L.max;

    if (qtyInput) {
      if (L.max === null) qtyInput.removeAttribute('max');
      else qtyInput.max = Math.max(1, Math.floor(L.max / L.min));
    }
  }

  function resolve(wrapper, strict) {
    const qtyInput  = wrapper.querySelector('.cartorderQty');
    const unitInput = wrapper.querySelector('.cartmeterQty');
    const isMeter   = !!qtyInput;

    const L = limits(wrapper);
    syncAttrs(wrapper, L);

    if (L.soldOut) return { qty: 1, units: 0, total: 0, soldOut: true, L: L };

    let qty = isMeter ? parseInt(qtyInput.value, 10) : 1;
    if (isNaN(qty) || qty < 1) qty = 1;

    let units = parseInt(unitInput.value, 10);
    if (isNaN(units)) units = L.min;

    let over = false;

    if (units < L.min) units = L.min;
    units = Math.round(units / L.step) * L.step;
    if (units < L.min) units = L.min;

    if (L.max !== null && units > L.max) { units = L.max; over = true; }

    if (L.max !== null && qty * units > L.max) {
      qty = Math.max(1, Math.floor(L.max / units));
      over = true;
    }

    if (strict) {
      if (isMeter) qtyInput.value = qty;
      unitInput.value = units;
      const hidden = wrapper.querySelector('.meterHidden');
      if (hidden) hidden.value = units;
    }

    return { qty: qty, units: units, total: qty * units, over: over, L: L };
  }

  function findLine(cart, wrapper) {
    const token = wrapper.dataset.lineToken;
    if (token) {
      const hit = cart.items.find(function (i) {
        return i.properties && i.properties._timestamp === token;
      });
      if (hit) return hit;
    }
    return cart.items[parseInt(wrapper.dataset.lineIndex, 10) - 1];
  }

  function updateRow(wrapper) {
    if (busy) return;

    const qtyInput  = wrapper.querySelector('.cartorderQty');
    const unitInput = wrapper.querySelector('.cartmeterQty');
    const line      = wrapper.dataset.lineIndex;

    if (!unitInput || !line) return;

    const isMeter  = !!qtyInput;
    const unitProp = wrapper.dataset.unitProperty || 'Meter';
    const unitWord = unitProp.toLowerCase();

    const v = resolve(wrapper, true);

    if (v.soldOut) {
      showNotice(wrapper, 'This item is out of stock.', true);
      return;
    }

    if (v.over) {
      showNotice(wrapper, 'Only ' + v.L.stock + ' ' + unitWord + ' available.', false);
    } else if (v.L.reduced) {
      showNotice(wrapper, 'Only ' + v.L.stock + ' ' + unitWord +
                 ' in stock — below the usual minimum of ' + v.L.moq + '.', false);
    } else {
      showNotice(wrapper, '');
    }

    function propsFrom(existing, q, u) {
      const p = Object.assign({}, existing || {});
      if (isMeter) { p['Qty'] = q; p['Meter'] = u; }
      // else { p[unitProp] = u; }
      return p;
    }

    busy = true;
    wrapper.classList.add('is-busy');

    function done() { busy = false; wrapper.classList.remove('is-busy'); }

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        const lineItem = findLine(cart, wrapper);
        if (!lineItem) { console.warn('Line item not found:', line); return done(); }

        const host = document.body.classList.contains('template-cart')
          ? document.querySelector('theme-cart')
          : document.querySelector('cart-drawer');

        if (!host || typeof host.updateQuantity !== 'function') {
          console.warn('Cart element not found — cannot update quantity/properties.');
          return done();
        }

        host.updateQuantity(line, v.total, propsFrom(lineItem.properties, v.qty, v.units));

        // verify what Shopify actually accepted
        setTimeout(function () {
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (after) {
              const live = findLine(after, wrapper);
              if (!live) return done();

              const el = document.querySelector(
                '.custom-meter-order[data-line-token="' + wrapper.dataset.lineToken + '"]'
              ) || wrapper;

              el.dataset.lineKey = live.key;

              if (live.quantity < v.total) {
                el.dataset.available = String(live.quantity);

                const fixed = resolve(el, true);

                host.updateQuantity(
                  line,
                  fixed.total,
                  propsFrom(live.properties, fixed.qty, fixed.units)
                );

                showNotice(el, 'Only ' + live.quantity +
                           ' available — quantity adjusted.', false);
              }
              done();
            });
        }, 600);
      })
      .catch(function (err) {
        console.error('Cart update failed', err);
        showNotice(wrapper, 'Could not update. Please try again.', false);
        done();
      });
  }

  document.addEventListener('change', function (e) {
    if (!e.target.matches('.cartorderQty, .cartmeterQty')) return;
    e.stopPropagation();
    const wrapper = e.target.closest('.custom-meter-order');
    if (wrapper) updateRow(wrapper);
  }, true);

  // warn while typing, without fighting the caret
  document.addEventListener('input', function (e) {
    if (!e.target.matches('.cartorderQty, .cartmeterQty')) return;
    const wrapper = e.target.closest('.custom-meter-order');
    if (!wrapper) return;

    const L = limits(wrapper);
    if (L.max === null) return;

    const unitInput = wrapper.querySelector('.cartmeterQty');
    const qtyInput  = wrapper.querySelector('.cartorderQty');
    const u = parseInt(unitInput.value, 10) || 0;
    const q = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

    if (q * u > L.max) {
      showNotice(wrapper, 'Only ' + L.max + ' available.', true);
    } else {
      showNotice(wrapper, '', false);
    }
  }, true);

})();